import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { connectedUsersQueryParams } from "@/app/oauth/accounts/query-params";
import type { ConnectedUsersFilters } from "@/app/oauth/accounts/search";
import type { ConnectedAccountsResponse } from "@/app/oauth/types";
import type { ScopedBinding } from "@/app/types";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { connectedAccountsKeys } from "./query-keys";

export type ConnectedAccountsListParams = {
  binding?: ScopedBinding;
  filters: ConnectedUsersFilters;
  limit: number;
  offset: number;
};

export const connectedAccountsQueryOptions = ({
  binding = "project",
  filters,
  limit,
  offset,
  scope,
}: ConnectedAccountsListParams & { scope: OrgProjectScope }) =>
  queryOptions<ConnectedAccountsResponse>({
    queryKey: connectedAccountsKeys.list({
      binding,
      scope,
      filters,
      limit,
      offset,
    }),
    queryFn: async () => {
      const { data } = await getEngineApi(
        scope,
        binding
      ).get<ConnectedAccountsResponse>("/user_connections", {
        params: { limit, offset, ...connectedUsersQueryParams(filters) },
      });
      return data;
    },
    placeholderData: keepPreviousData,
  });
